module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point1_5-058fb18f9d2f54f969bb8da221460c87.jpg";